/**
 *
 * Email Integration
 *
 */

import React, { FC } from 'react';

import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';

import { Form, FormAction } from 'components/index';
import { useIntegrations } from 'containers/Setup/Integrations/hooks/useIntegrations';
import { selectIntegrations } from 'containers/Setup/Integrations/selectors';

interface Props {
  onSubmit: (data: any) => void;
  setEmailIDs: (emailIDs: string[]) => void;
  emailIDs: string[];
  actionType?: FormAction;
}

export const EmailForm: FC<Props> = props => {
  const { onSubmit, emailIDs, setEmailIDs, actionType } = props;
  const { client, activeClient } = useSelector(selectIntegrations);
  const { onCancel } = useIntegrations();
  const { data: currentRecord } = activeClient;

  return (
    <Form
      isLoading={activeClient.isLoading}
      schema={{
        name: {
          type: 'text',
          label: 'Name',
          isRequired: true,
          defaultValue: currentRecord?.name,
          tooltip: 'Only alphanumeric, underscore,period allowed',
          isDisabled: client.isLoading,
          autoFocus: true,
        },
        email_group: {
          type: 'emailIds',
          label: 'Username: Email IDs (Press enter to add)',
          value: emailIDs,
          onChange: setEmailIDs,
          isRequired: true,
        },
      }}
      buttonOptions={{
        submit: {
          name: actionType === 'Add' ? 'OK' : actionType?.toUpperCase(),
          isLoading: client.isLoading,
          isDisabled: client.isLoading || isEmpty(emailIDs),
        },
        reset: {
          name: 'CANCEL',
          isVisible: true,
          isDisabled: client.isLoading,
          onClick: onCancel,
        },
      }}
      handleSubmit={onSubmit}
    />
  );
};
